import { Entry } from "contentful";
import { ExternalLinkSkeleton } from "@/types/contentful/common/external-link";

 export interface MappedExternalLink {
  id: string;
  title: string;
  url: string;
  openInNewTab: boolean;

}

const mapExternalLink = (entry: Entry<ExternalLinkSkeleton> | undefined): MappedExternalLink => {
  if (!entry || !entry.fields) {
    return {
      id: "",
      title: "",
      url: "#",
      openInNewTab: false
    };
  }
  return {
    id: entry.sys.id,
    title: entry.fields.title?.toString() ?? "",
    url: entry.fields.url?.toString() ?? "#",
    openInNewTab: !!entry.fields.openInNewTab
  };
};

export default mapExternalLink;